import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    
    // Liste des endpoints qui ne doivent pas déclencher de déconnexion sur 401
    // Ces endpoints peuvent retourner 401 pour des raisons métier (non lié, etc.)
    // - /auth/google/session : l'écran AuthCallback affiche lui-même l'erreur métier
    //   (email inconnu, session expirée, service injoignable) — pas de redirect forcé
    const skipLogoutEndpoints = ["/odysboard/", "/coach/comments/", "/auth/google/"];
    const shouldSkipLogout = skipLogoutEndpoints.some(ep => url.includes(ep));
    
    // 401 = token expiré/invalide → redirection login (sauf pour certains endpoints)
    // 403 sans token stocké = non authentifié → redirection login
    if (!shouldSkipLogout && (status === 401 || (status === 403 && !localStorage.getItem("token")))) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
